import { Component, OnInit, TemplateRef, ViewChild, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import moment from "moment";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { ESTADO_NOTA, NotaOperacaoGarantida, TIPO_CLASSE_OPERACAO } from "src/app/model/nota.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { NotasService } from "../notas.service";

//import Utils from "src/app/shared/fgi-utils";

@Component({
    templateUrl: './notas-pesquisa.component.html',
    standalone: false
})
export class NotasPesquisaComponent implements OnInit{
   
    @ViewChild('desativacao') desativacao: TemplateRef<any>;
    @ViewChild('desativacaoBotoes') desativacaoBotoes: TemplateRef<any>;
  
    private cnpjUsuario: string;
    private pesquisaForm:UntypedFormGroup = null;
    private pesquisado: boolean = false; // usado no html
    public esconderPesquisa: boolean = true;
    private opcoesPaginacao: number[];
    private notas:NotaOperacaoGarantida[]=[];
    private agentesFinanceiros:AgenteFinanceiro[]=[];
    private atributosPaginacaoComponenteListagem: EntityPagedResult<NotaOperacaoGarantida>;
    private podeCadastrarNota: boolean = true;
    private classesOperacao = TIPO_CLASSE_OPERACAO;
    private estados = ESTADO_NOTA;
    private valoresPesquisaForm: any;
    private dataHoraResultado: string;
    private notaDesativando: NotaOperacaoGarantida;
    
    
    constructor(
        private modalService: BnModalMessageService,
        private formBuilder:UntypedFormBuilder,
        private activatedRoute:ActivatedRoute,
        private permissaoService: PermissaoService,
        private messageService: MessageChannelService,
        private notasService:NotasService,
        ){
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };            
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }

    ngOnInit(): void {
        this.pesquisaForm = this.createReactiveForm();
    
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
          this.podeCadastrarNota = resp && resp[ROLE_GESTOR_ENVIO];
          this.construirFormulario();
          sessionStorage.getItem('notasPesquisaFiltrado')==='S' && this.buscar();
        });
    }

    createReactiveForm(): UntypedFormGroup {
       
        const f = this.formBuilder.group({
            agenteFinanceiro: null,
            classeOperacao: null,
            idOperacaoExterno:  [null,[Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
            contratoRepasse:    [null,[Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
            estado:null
        });         
    
        f.get('classeOperacao').valueChanges.subscribe(sist => {
            const contratoRepasse = f.get('contratoRepasse');
            const idOperacaoExterno = f.get('idOperacaoExterno');
            if (!sist) {
                idOperacaoExterno.enable();
                contratoRepasse.enable();
                return;
            }
            if (sist === 'CL') {   
                idOperacaoExterno.enable();
                contratoRepasse.disable();
            } else {
                contratoRepasse.enable();
                idOperacaoExterno.disable();
            }
            contratoRepasse.updateValueAndValidity();
            idOperacaoExterno.updateValueAndValidity();
        });
    
        return f;
      }
    

    private construirFormulario() {

        const valoresSessao = sessionStorage.getItem('valoresPesquisaNotaForm');
        this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : null;
        
        if (this.valoresPesquisaForm) {
          const agenteSelecionado = this.retornaAgenteFinanceiro(this.valoresPesquisaForm.agenteFinanceiro?.id);
          this.pesquisaForm.setValue({
            agenteFinanceiro: agenteSelecionado,
            classeOperacao: this.valoresPesquisaForm.classeOperacao ? this.valoresPesquisaForm.classeOperacao : null,
            contratoRepasse: this.valoresPesquisaForm.contratoRepasse ? this.valoresPesquisaForm.contratoRepasse: null,
            idOperacaoExterno: this.valoresPesquisaForm.idOperacaoExterno ? this.valoresPesquisaForm.idOperacaoExterno : null,
            estado: this.valoresPesquisaForm.estado ? this.valoresPesquisaForm.estado : null,
          });

        }
        this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
            this.valoresPesquisaForm = novosValores;
            sessionStorage.setItem('valoresPesquisaNotaForm', JSON.stringify(this.valoresPesquisaForm));
        });
    }

    mudancaPagina(novaPagina: EntityPagedResult<NotaOperacaoGarantida>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.esconderPesquisa = true;
        this.buscar();
    }

    retornaAgenteFinanceiro(id:number){
        return id ? this.agentesFinanceiros
                          .filter( agente => agente.id==id)[0] : null;
    }

    limpar() {
        sessionStorage.setItem('notasPesquisaFiltrado', 'N');
        this.pesquisaForm.reset({
            classeOperacao: null
        }); 
        this.notas = [];    
        this.pesquisado = true;
        this.atributosPaginacaoComponenteListagem.page = 1;
    }

    buscar(){
        if(!this.esconderPesquisa){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        this.notasService.getNotas(this.obterFiltrosBusca()).subscribe( response=>{
            this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
            this.notas = response.resultados;
            this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
            this.pesquisado = true;
            this.esconderPesquisa = false;
        });
        sessionStorage.setItem('notasPesquisaFiltrado', 'S');
    }

    obterFiltrosBusca(){
        const form = this.pesquisaForm.value;
        let dadosPreenchidos:any = {};  

        if(form.agenteFinanceiro)
            dadosPreenchidos.idAgenteFinanceiro = form.agenteFinanceiro.id;
        if(form.classeOperacao)
            dadosPreenchidos.classeOperacao = form.classeOperacao;
        if(form.idOperacaoExterno)
            dadosPreenchidos.idOperacaoExterno = form.idOperacaoExterno;
        if(form.contratoRepasse)
            dadosPreenchidos.contratoRepasse = form.contratoRepasse;
        if (form.estado) {
            dadosPreenchidos.ativo = form.estado;
        }
        dadosPreenchidos.pagina = this.atributosPaginacaoComponenteListagem.page;
        dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        return dadosPreenchidos;
    }

    
  desativacaoNota(nota: NotaOperacaoGarantida) {
    this.notaDesativando = nota;
    this.modalService
      .abrir('Desativação de Nota', null, 'lg', this.desativacao, this.desativacaoBotoes).result
      .then((notaDesativado) => {
            this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Nota desativado com sucesso.'
            });
            //this.ocorrencias = [];      
            this.buscar();
        }, (reason) => {
          console.log(reason);
        }
      );
  }
  
  confirmaDesativacao() {
    
    this.notaDesativando.ativo = 'N';
    this.notasService['save'](this.notaDesativando)
        .subscribe(notaDesativada => {
            this.modalService.close(notaDesativada);
        }, error => {
            console.log(error);
        });        
  }

  cancelaDesativacao() {
    this.modalService.dismiss("abortou desativação");
  }

}
